<div class="error-page">
  <h2 class="title font-secondary">404</h2>
  <a href="/"
     class="cta">Homepage</a>
</div>